export default {"src":"/_next/static/media/plus_regular.fd0d5e07.svg","height":24,"width":24};